// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"3c872ec9","453":"abd36b29","479":"9d9594a7","522":"76ebf4fd","550":"60463094","633":"c43afb25"}[chunkId] + ".chunk.js";
};